import * as React from 'react';

import { SelectControlOption, SelectControl } from 'types/state';
import { SelectBoxOption } from './selectBoxOptionComponents';
import { SelectBoxWrapper } from './selectBoxWrapperComponents';

type OptionMemoizerProps<ValueType> = {
  option: SelectControlOption<ValueType>;
  onSelect(value: ValueType): void;
};

function SelectBoxOptionMemoizer<ValueType extends string>(
  props: OptionMemoizerProps<ValueType>
) {
  const { onSelect, option } = props;

  const onClick = React.useCallback(() => {
    onSelect(option.value);
  }, [onSelect, option.value]);

  return (
    <SelectBoxOption
      title={option.title || option.value}
      description={option.description}
      onClick={onClick}
    />
  );
}

export function SelectBox<ValueType extends string>(
  props: SelectControl<ValueType>
) {
  const { options, onSelectValue } = props;

  const optionsNode = React.useMemo(() => {
    return options.map((option) => {
      return (
        <SelectBoxOptionMemoizer
          key={option.value}
          option={option}
          onSelect={onSelectValue}
        />
      );
    });
  }, [onSelectValue, options]);

  return <SelectBoxWrapper>{optionsNode}</SelectBoxWrapper>;
}
